import { Page } from '@roc/feature-app-core';
import { Route } from 'react-router';
import { ExternalAgentHome } from '../titleAgent/externalAgentHome';
import { InvoicesDashboard } from '../titleAgent/components/invoicesDashboard';

export const getDashboardRoutesConfig = (basePath: string, baseUrl: string) => {
  return {
    dashboard: {
      path: `${basePath}/dashboard`,
      url: `${baseUrl}/dashboard`,
      documentTitle: 'Dashboard',
    },
    invoicesDashboard: {
      path: `${basePath}/invoices-dashboard`,
      url: `${baseUrl}/invoices-dashboard`,
      documentTitle: 'Invoices Dashboard',
    },
  };
};

export const getDashboardRoutes = (basePath: string, baseUrl: string) => {
  const config = getDashboardRoutesConfig(basePath, baseUrl);
  console.log(config);
  return {
    dashboard: (
      <Route exact path={config.dashboard.path}>
        <Page routeDefinition={config.dashboard}>
          <ExternalAgentHome />
        </Page>
      </Route>
    ),
    invoicesDashboard: (
      <Route exact path={config.invoicesDashboard.path}>
        <Page routeDefinition={config.invoicesDashboard}>
          <InvoicesDashboard />
        </Page>
      </Route>
    ),
  };
};
